import { Alert } from "flowbite-react";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FiAlertOctagon } from "react-icons/fi";
import { formatToReal } from "../../../utils/utils";

const AvisoCard = ({
  hasRestrictions,
  title,
  messageError,
  messageSuccess = "Nada consta",
  value = 0,
}) => {
  return (
    <>
      {!hasRestrictions ? (
        <div className="flex relative flex-col rounded-md font-semibold pt-1 pb-6 px-2 bg-green-100 border-2 border-green-500 min-h-28">
          <div className="text-left text-sm text-green-800">{title}</div>
          <div className="text-center font-semibold bg-green-100 w-fit text-green-800 px-2 rounded-md mx-auto mt-4">
            Nada consta
          </div>
        </div>
      ) : (
        <div className="flex relative flex-col rounded-md font-semibold pt-1 pb-6 px-2 bg-red-100 border-2 border-red-500 min-h-28">
          <div className="text-left text-sm text-red-800">{title}</div>
          <div className="text-center font-semibold bg-red-100 w-fit text-red-800 px-2 rounded-md mx-auto mt-4">
            {messageError}
          </div>
          {value != "0" && (
            <div className="text-center font-semibold bg-red-100 w-fit text-red-800 px-2 rounded-md mx-auto mt-2">
              {formatToReal(value)}
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default AvisoCard;
